import React from 'react';

export function SkeletonBlock({ className = '' }: { className?: string }) {
  return (
    <div className={`animate-pulse bg-white/5 rounded-md ${className}`} />
  );
}

export function StatCardSkeleton() {
  return (
    <div className="glass-card rounded-xl border border-border p-5 animate-pulse">
      <div className="flex items-center justify-between mb-4">
        <div className="h-3 w-20 bg-white/5 rounded" />
        <div className="h-8 w-8 bg-white/5 rounded-lg" />
      </div>
      <div className="h-8 w-16 bg-white/8 rounded mb-2" />
      <div className="h-2.5 w-24 bg-white/5 rounded" />
    </div>
  );
}

export function TableRowSkeleton({ cols = 6 }: { cols?: number }) {
  return (
    <tr className="border-b border-border/50">
      {Array.from({ length: cols }).map((_, i) => (
        <td key={`skel-col-${i}`} className="px-4 py-3">
          <div className="h-4 bg-white/5 rounded animate-pulse" style={{ width: `${60 + (i % 3) * 15}%` }} />
        </td>
      ))}
    </tr>
  );
}